module.exports = __webpack_public_path__ + "media/images/no-image-4031bb41108a1756d5556efc02346660.png";